export const REMIND_OPTIONS = { none: "Hatırlatma yok", 15: "15 dk önce", 60: "1 saat önce", 1440: "1 gün önce" };
export const EVENT_KINDS = { APPOINTMENT: "Randevu", EVENT: "Etkinlik" };
export const EVENT_STATUS = { PLANNED: "Planlandı", DONE: "Tamamlandı", CANCELLED: "İptal" };

const pad = (n) => String(n).padStart(2, "0");
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);
export const fmtDT = (iso) => new Date(iso).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });
export const dayKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
